import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsShipmentManagementServices = {
  //Shipment Management
  addNewStudySiteShipment,
  updateStudySiteShipment,
  receivedAtSiteShipment,
  approvedDispatchedSiteShipment,
  deleteStudySiteShipmentData,
  softDeleteRestoreStudySiteShipment,
  getStudySiteShipmentData,
};

// Add New Shipment
async function addNewStudySiteShipment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySiteShipment`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Shipment
async function updateStudySiteShipment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySiteShipment`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Received At Site Shipment
async function receivedAtSiteShipment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}receivedAtSiteShipment`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Approved Dispatched Shipment
async function approvedDispatchedSiteShipment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}approvedDispatchedSiteShipment`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Delete Shipment
async function deleteStudySiteShipmentData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySiteShipmentData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Shipment
async function softDeleteRestoreStudySiteShipment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySiteShipment`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Shipment
async function getStudySiteShipmentData(studyId, status, mode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteShipmentData/${studyId}/${status}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteShipmentData/${studyId}/${status}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}